import { string, bool } from 'prop-types';

export const addressTypes = {
  id: string,
  addressLine1: string,
  addressLine2: string,
  addressLine3: string,
  attention: string,
  city: string,
  cityStateZip: string,
  country: string,
  isLocked: bool,
  name: string,
  state: string,
  zipCode: string
};
